import axios from 'axios';

export const transferToEarnBetAsync = async ({
  cash,
  usdt,
  usdc,
  networkType
}: {
  cash: number;
  usdt: number;
  usdc: number;
  networkType: number | null;
}) => {
  const { data } = await axios.post(`/earnbet/topup`, {
    cash,
    usdt,
    usdc,
    networkType
  });

  return data;
};

export const checkEarnBetUserAsync = async () => {
  const { data } = await axios.get(`/earnbet/user-exists`);

  return data;
};
